if(!customElements.get('td-reels')) {

  class TdReels extends HTMLElement {
    constructor() {
      super();
      
      
    }
      connectedCallback() {
        this.soundOn = false;
        this.thumbnails = Array.from(this.querySelectorAll('.td-reels__thumbnail'));    
        this.controls = Array.from(this.querySelectorAll('.td-reels__slider-control'));
        this.arrows = Array.from(this.querySelectorAll('.td-reels__slider-arrow')); 
        this.overlay = this.querySelector('.td-reels__overlay');
        this.videos = Array.from(this.querySelectorAll('video'));
        if(this.arrows.length) this.arrows.map(arrow => arrow.addEventListener('click', this.handleArrowClick.bind(this)));
        if(this.thumbnails.length) this.thumbnails.map(thumbnail => thumbnail.addEventListener('click', this.handleThumbnailClick.bind(this)));
        if(this.overlay) this.overlay.addEventListener('click', this.handleCloseClick.bind(this));
        this.sliderContainer = this.querySelector('.td-reels__slider-container');
        this.sliderElement = this.querySelector('.keen-slider');
        this.closeButton = this.querySelector('.td-reels__slider-close');
        if(this.closeButton) this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
        this.soundControls = this.querySelector('.td-reels__slider-sound');
        if(this.soundControls) this.soundControls.addEventListener('click', this.handleSoundClick.bind(this));
        this.slider = this.initKeen()
        
      }
      handleThumbnailClick(e) {
        e.preventDefault();
        e.stopPropagation();
          if(this.thumbnails.length) this.thumbnails.map(thumbnail => thumbnail.classList.remove('td-reels__thumbnail--active'));
          e.target.classList.add('td-reels__thumbnail--active');
          
          const position = parseInt(e.target.getAttribute('data-position'));
          if(this.slider && position !== undefined) {   
              if(this.videos.length) this.videos.map(video => video.pause());          
              this.slider.moveToIdx(position)
              const currentVideo = this.slider.slides[position].querySelector('video');  
              
              if(currentVideo) {
             
                currentVideo.play();
                
             
              }
              
          }
          if(this.sliderContainer) {
            this.sliderContainer.classList.add('td-reels--active');
            this.sliderContainer.focus();
          }
          document.body.classList.add('td-reels--active');
         
      }
      handleCloseClick() {
        if(this.sliderContainer) {
          this.sliderContainer.classList.remove('td-reels--active');
        }
          const currentVideo = this.slider.slides[this.slider.track.details.rel].querySelector('video');            
          if(currentVideo) {
            currentVideo.muted = true;
          }
          if(this.soundControls) {
            this.soundControls.classList.add('td-reels__slider-sound--muted');  
          }
          if(this.thumbnails.length) this.thumbnails.map(thumbnail => thumbnail.classList.remove('td-reels__thumbnail--active'));
          document.body.classList.remove('td-reels--active');
          // mute all videos
          if(this.videos.length) this.videos.map(video => {
            video.muted = true
            video.pause();
          })
          this.soundOn = false;
      }
      toggleSound() {
        if(this.slider) {
          const currentVideo = this.slider.slides[this.slider.track.details.rel].querySelector('video');
           if(currentVideo) {
             currentVideo.muted = !currentVideo.muted;
             this.soundOn = !this.soundOn;
           }
         }
      }
      handleSoundClick() {
        if(this.soundControls) {
          this.soundControls.classList.toggle('td-reels__slider-sound--muted');  
          this.toggleSound()
        }
      }
      
      updateThumbnail(idx) {
        if(this.thumbnails.length) {
          this.thumbnails.map(thumbnail => thumbnail.classList.remove('td-reels__thumbnail--active'));
          this.thumbnails[idx].classList.add('td-reels__thumbnail--active');
        }
      }

      handleArrowClick(e) {
    
        e.preventDefault();
        e.stopPropagation();
        
        if(this.slider) {
         
          let currentSlide = null
          if(this.soundOn && this.videos.length) this.videos.map(video => {
            video.muted = true;
            video.pause();
          
          });
          if(e.target.classList.contains('td-reels__slider-arrow--up')) {
            this.slider.prev()
            currentSlide = this.slider.track.details.rel - 1 < 0 
            ? this.slider.slides[this.slider.slides.length - 1]
            : this.slider.slides[this.slider.track.details.rel - 1];      
            
            if(this.slider.track.details.rel - 1 < 0 ){
              this.updateThumbnail(this.slider.slides.length - 1)
            }else {
              this.updateThumbnail(this.slider.track.details.rel - 1)
            }

          } else if(e.target.classList.contains('td-reels__slider-arrow--down')) {
            this.slider.next()
            currentSlide = this.slider.track.details.rel + 1 < this.slider.slides.length 
            ? this.slider.slides[this.slider.track.details.rel + 1]
            : this.slider.slides[0];

            if(this.slider.track.details.rel + 1 < this.slider.slides.length){
              this.updateThumbnail(this.slider.track.details.rel + 1) 
            }else {
              this.updateThumbnail(0)
            }
          }
          if(currentSlide) {
            const currentVideo = currentSlide.querySelector('video');
            if(currentVideo) {
              if(this.soundOn) currentVideo.muted = false;
              currentVideo.play();
              
            }
          
          }
          

        }
      }
      initKeen() {       
        
        const options = {
          loop: true,
          slides: {           
            perView: 1,
            spacing: 0,
          },
          vertical: true
        }
        if(this.sliderElement) {
          const slider = new KeenSlider(this.sliderElement, options, []);  
          return slider;
        }
        
      }
  }
  customElements.define('td-reels',TdReels);
  }